import { FetchedReportData } from "../types";
import { formatDate } from "./dateUtils";

const formatDetails = (
  details?: { [key: string]: string } | null | undefined
) => {
  return details
    ? Object.entries(details)
        .map(([key, value]) => (value ? `${key}: ${value}` : null))
        .filter(Boolean)
        .join(", ")
    : "N/A";
};

const formatUrls = (urls?: string[] | null | undefined) => {
  if (!urls || urls.length === 0) return "N/A";
  return urls.join(", ");
};

export const filteredReportDataForCSV = (
  selectedReports: FetchedReportData[]
) =>
  selectedReports.map((report) => ({
    ID: report._id,
    reportId: report.reportId || "N/A",
    caseName: report.caseName || "N/A",
    caseType: report.caseType || "N/A",
    incidentDate: formatDate(report.incidentDescription.date) || "N/A",
    incidentLocation: report.incidentDescription.location || "N/A",
    onlineIncidentLocation:
      report.incidentDescription.digitalcaseLinks?.join(", ") || "N/A",
    city: report.incidentDescription.detailedLocation.city || "N/A",
    county: report.incidentDescription.detailedLocation.county || "N/A",
    state: report.incidentDescription.detailedLocation.state || "N/A",
    incidentNarration: report.incidentDescription.description || "N/A",
    incidentPhotoEvidence: formatUrls(
      report.incidentDescription.incidentPhotoEvidence
    ),
    incidentVoiceNarration: formatUrls(
      report.incidentDescription.incidentVoiceNarration
    ),
    reporterAge: report.reporterDetails.age || "N/A",
    reporterEmail: report.reporterDetails.email || "N/A",
    reporterGender: report.reporterDetails.gender || "N/A",
    reporterPhone: report.reporterDetails.phone || "N/A",
    reporterRole: report.reporterDetails.role || "N/A",
    reporterSocials: formatDetails(report.reporterDetails.socials),
    hasAbuserInfo: report.hasAbuserInfo ? "Yes" : "No",
    abuserName: report.abuserDetails?.name || "N/A",
    abuserNickname: report.abuserDetails?.nickname || "N/A",
    abuserGender: report.abuserDetails?.gender || "N/A",
    abuserAge: report.abuserDetails?.refAge || "N/A",
    abuserPhyDescription: report.abuserDetails?.phyDescription || "N/A",
    hasAbuserVehicleInfo: report.abuserDetails?.hasAbuserVehicleInfo
      ? "Yes"
      : "No",
    hasSpecialAuthority: report.abuserDetails?.hasSpecialAuthority
      ? "Yes"
      : "No",
    specialAuthorityPosition:
      report.abuserDetails?.specialAuthorityPosition || "N/A",
    occupation: report.abuserDetails?.occupation || "N/A",
    relationToVictim: report.abuserDetails?.relationToVictim || "N/A",
    abuserVehicleInfo: formatDetails(report.abuserDetails?.vehicleInfo),
    abuserSocials: formatDetails(report.abuserDetails?.socials),
    needAttorney: report.NeedAnAttorney ? "Yes" : "No",
    needCounseling: report.NeedCounseling ? "Yes" : "No",
    needPrivateInvestigator: report.NeedPrivateInvestigator ? "Yes" : "No",
    status: report.status || "N/A",
    createdAt: formatDate(report.createdAt, "mmddyyyy") || "N/A",
  }));
